import { func, string, boolean } from "prop-types";
import React, { useState } from "react";
import CustomInput from "../CustomInput";
import axios from "axios";
function SearchLocationInput({ handleLocationChange, inputStyle, isRequired, value }) {
  const [locations, setLocations] = useState({});
  const searchLocations = async (city) => {
    try {
      const {
        data: { cities },
      } = await axios.get(`https://workbrook.us/anonymous/cities/${city}`);
      setLocations(cities);
    } catch (error) {
      //
    }
  };
  return (
    <div className="search-location-input">
      <div className="custom-text-field mt-3 w-100">
        <label className="d-block" htmlFor="autoCompleteLocations">
          Location
          {isRequired && <span className="co-lightred"> * </span>}
        </label>
        <div className="input-wrapper">
          <input
            className="w-100 form-control"
            type="text"
            id="autoCompleteLocations"
            required={isRequired}
            onChange={(e) => {
              if (e.target.value.length > 3) {
                searchLocations(e.target.value);
              }
              handleLocationChange(e.target.value);
            }}
            placeholder="Enter a City"
            inputStyle={inputStyle}
            value={value}
            list="locationsResult"
            style={{
              padding: '12px 16px',
              borderRadius: '10px',
              border: '1px solid #ddd',
              fontSize: '14px',
              transition: 'all 0.3s ease',
              backgroundColor: '#fff',
              outline: 'none',
            
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#000';
              e.target.style.boxShadow = '0 0 0 3px rgba(0, 0, 0, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#ddd';
              e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
          />
          
          <datalist id="locationsResult">
            {Object.values(locations).length > 0 &&
              Object.values(locations).map((item) => (
                <option
                  key={`${item.name}, ${item.subcountry}, ${item.country}`}
                  value={`${item.name}, ${item.subcountry}, ${item.country}`}
                />
              ))}
          </datalist>
        </div>
      </div>
    </div>
  );
}

SearchLocationInput.propTypes = {
  handleLocationChange: func.isRequired,
  inputStyle: string,
  isRequired: boolean,
};

CustomInput.defaultProps = {
  inputStyle: "",
};
export default SearchLocationInput;
